import { authorClient } from "@/api/authorClient";
import { setCommon } from "@/utils/request";
import { setMetaData } from "@/utils";
// import router from '@/router'
//  lee  获取角色分类
interface RoleOptions {
  trackId?: string;
  clientId?: string;
  token: string;
}
function getRoleOptionsApi(arg: RoleOptions) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = setCommon();
      await authorClient.listUserGroup(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            let _res: any = {};
            if (!res.commonout || res.commonout.code == 0) {
              _res.status = "success";
              _res.data = res.usergroupinfosList;
            } else {
              _res.status = "error";
              _res.message = res.commonout.errmsg;
            }
            resolve(_res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  });
}
export async function getRoleOptions(arg: RoleOptions) {
  // router.push("/login");
  return await getRoleOptionsApi(arg);
}
// async function getRoleOptionsAsync(arg: RoleOptions) {
//     // router.push("/login");
//     return await getRoleOptionsApi(arg);
// }
// export function getRoleOptions(arg: RoleOptions, options: any){
//     getRoleOptionsAsync({
//         trackId: "",
//         clientId: "",
//         token: arg.token
//     }).then((res: any) => {
//         switch(res.status){
//             case 'success':
//                 options = res.data;
//                 break;
//             case 'code':
//                 router.push("./login");
//                 break;
//             case 'error':
//                 // this.$message.error(res.message);
//                 break;
//         }
//     }).catch((err: any) => {
//         if (err.code == 16) {
//             router.push("./login");
//         }
//     });
// }
